export default __webpack_public_path__ + "static/media/réglement_nav_icon.c7d3a6e5.svg";